import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";

export const PricingSubtitle: React.FC = ({ children }) => {
  const { css } = useFela();
  const { colors } = useTheme();

  return (
    <span
      className={css({
        fontWeight: "bold",
        fontSize: 12,
        lineHeight: "16px",
        letterSpacing: 0.25,
        textTransform: "uppercase",
        color: colors.LIGHT_GRAY,
      })}
    >
      {children}
    </span>
  );
};
